var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import SessionUtil from 'edge/quoteandbind/common/util/SessionUtil';
import _ from 'lodash';

var ViewBuildingCtrl = function () {
    function ViewBuildingCtrl($scope, $state, StateUtils, ModalService, $filter, cpDeleteBuildingService) {
        var _this = this;

        _classCallCheck(this, ViewBuildingCtrl);

        this.$state = $state;
        this.model = StateUtils.activeDataForState(true).model;
        this.sessionId = SessionUtil.getSessionUUID(this.model);
        this.$filter = $filter;
        this.$scope = $scope;
        $scope.isBuildingUpdated = $state.params.isBuildingUpdated;
        $scope.isCoverageOpen = $state.params.isCoverageOpen;
        $scope.areCoveragesUpdated = $state.params.areCoveragesUpdated;
        $scope.isLocationUpdated = $state.params.isLocationUpdated;

        getBuildingData(this.model, $state.params.publicID);

        function getBuildingData(model, buildingId) {
            $scope.location = _.find(model.lobData.commercialProperty.coverables.locations.value, function (location) {
                return _.find(location.buildings, function (currentBuilding) {
                    if (currentBuilding.publicID === buildingId) {
                        $scope.building = currentBuilding;
                        return location;
                    }
                });
            });
        }

        this.deleteBuilding = function () {
            var locations = _this.model.lobData.commercialProperty.coverables.locations.value;

            cpDeleteBuildingService.deleteBuilding(_this.model, $scope.location, $scope.building).then(function () {
                if (locations.every(function (loc) {
                    return loc.buildings.length === 0;
                })) {
                    $state.go('cpBuildingWizardInitialScreen');
                } else {
                    $state.go('cpBuildingWizardBuildingsList');
                }
            }).catch(function (error) {
                if (error) {
                    ModalService.showError('quoteandbind.cp.directives.cp-building-view.Building not removed', 'quoteandbind.cp.views.cp-building-view.Please check for errors and try again');
                }
            });
        };
    }

    _createClass(ViewBuildingCtrl, [{
        key: 'removeBuilding',
        value: function removeBuilding() {
            this.deleteBuilding();
        }
    }, {
        key: 'editLocation',
        value: function editLocation() {
            this.$state.go('cpBuildingWizardEditLocation', { publicID: this.$scope.location.publicID, buildingPublicID: this.$scope.building.publicID });
        }
    }]);

    return ViewBuildingCtrl;
}();

ViewBuildingCtrl.$inject = ['$scope', '$state', 'StateUtils', 'ModalService', '$filter', 'qnb.cpDeleteBuildingService'];

export default ViewBuildingCtrl;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-cp-components-angular/buildingsWizard/ViewBuilding/ViewBuildingCtrl.js
// module id = 992
// module chunks = 0